import React from 'react';
import './Card.css';

interface CardProps {
  children: React.ReactNode;
  variant?: 'default' | 'elevated' | 'bordered';
  padding?: 'none' | 'small' | 'medium' | 'large';
  className?: string;
  onClick?: () => void;
}

export const Card: React.FC<CardProps> = ({
  children,
  variant = 'default',
  padding = 'medium',
  className = '',
  onClick
}) => {
  const cardClass = `
    card 
    card--${variant} 
    card--padding-${padding}
    ${onClick ? 'card--clickable' : ''}
    ${className}
  `.trim();

  return (
    <div className={cardClass} onClick={onClick}>
      {children}
    </div>
  );
};